import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Routes } from "react-router-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import Home from "./Home";
import About from "./About";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Login from "./Login";
import Dashboard from "./Dashboard";
import HouseDetail from "./HouseDetail";
import HouseForm from "./admin/HouseForm";
import SiteSettings from "./admin/SiteSettings";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:id" element={<HouseDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
            <Route path="/dashboard/house/new" element={
              <ProtectedRoute><HouseForm /></ProtectedRoute>
            } />
            <Route path="/dashboard/house/:id/edit" element={
              <ProtectedRoute><HouseForm /></ProtectedRoute>
            } />
            <Route path="/dashboard/settings" element={
              <ProtectedRoute><SiteSettings /></ProtectedRoute>
            } />
          </Routes>
          <Footer />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
